import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [
    {
      id: "1",
      name: "Wireless Headphones",
      price: "199",
      url: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=500",
      category: "Electronics",
      rating: 4.5,
      stock: 12,
      description: "High-fidelity audio with active noise cancellation.",
    },
    {
      id: "2",
      name: "Modern Smartwatch",
      price: "299",
      url: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500",
      category: "Accessories",
      rating: 4.8,
      stock: 5,
      description: "Health tracking and premium design in one piece.",
    },
    {
      id: "3",
      name: "Mechanical Keyboard",
      price: "149",
      url: "https://images.unsplash.com/photo-1511467687858-23d96c32e4ae?w=500",
      category: "Electronics",
      rating: 4.2,
      stock: 0,
      description: "Tactile switches with customizable RGB lighting.",
    },
    {
      id: "4",
      name: "Ergonomic Chair",
      price: "450",
      url: "https://images.unsplash.com/photo-1592078615290-033ee584e267?w=500",
      category: "Furniture",
      rating: 4.7,
      stock: 8,
      description: "Maximum comfort for long-duration productivity.",
    },
  ],
  keyword: "",
  categoryFilter: "All",
};

const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    createDataFunc: (state, action) => {
      state.data = [...state.data, action.payload];
    },
    sortingDataFunc: (state, action) => {
      state.data.sort((a, b) => {
        if (action.payload === "asc") return Number(a.price) - Number(b.price);
        if (action.payload === "desc") return Number(b.price) - Number(a.price);
        return 0;
      });
    },
    deleteDataFunc: (state, action) => {
      state.data = state.data.filter(
        (dt) => dt.id.toString() !== action.payload.toString(),
      );
    },
    updateDataFunc: (state, action) => {
      state.data = state.data.map((dt) =>
        dt.id.toString() === action.payload.id.toString()
          ? { ...dt, ...action.payload }
          : dt,
      );
    },
    searchDataFunc: (state, action) => {
      state.keyword = action.payload;
    },
    filterCategoryFunc: (state, action) => {
      state.categoryFilter = action.payload;
    },
  },
});

export const {
  createDataFunc,
  sortingDataFunc,
  deleteDataFunc,
  updateDataFunc,
  searchDataFunc,
  filterCategoryFunc,
} = dataSlice.actions;

export default dataSlice.reducer;
